module.exports = __webpack_public_path__ + "img/432322_5E3839_170C0B_543433-256px.905faf88.png";